import currencyMixin from "@/mixins/currencyMixin";
import dobrouGmr from "@/utils/dobrouGmr";

/**
 * Linha de bonus sobre comissao: nao representa item nem atingimento,
 * so pagamento. Vem sem id_produto, valor_meta e valor_realizado.
 */
export function ehLinhaComissao(row) {
  return String((row && row.tipo_linha) || "").trim().toUpperCase() === "C";
}

const apuracaoTipoMixin = {
  mixins: [currencyMixin],

  props: {
    meta:    { type: Object, required: true },
    search:  { type: String, default: "" },
    gmrInfo: { type: Object, default: null }
  },

  data() {
    return {
      filters: {
        empresa:    null,
        funcao:     null,
        ganhouMeta: null
      }
    };
  },

  computed: {
    labelGmr() {
      const gmr = this.gmrInfo;
      return gmr && dobrouGmr(gmr.crescimento_gmr, gmr.percentual_dobro) ? "× 2" : "Bônus liberado";
    },

    opcoesEmpresa() {
      return [...new Set(this.meta.rows.map(r => r.apelido || r.nome_empresa).filter(Boolean))].sort();
    },

    opcoesFuncao() {
      return [...new Set(this.meta.rows.map(r => r.funcao).filter(Boolean))].sort();
    },

    rowsBase() {
      return this.meta.rows.filter(r => {
        if (this.filters.empresa && (r.apelido || r.nome_empresa) !== this.filters.empresa) return false;
        if (this.filters.funcao  && r.funcao !== this.filters.funcao) return false;
        if (this.filters.ganhouMeta) {
          const val = r.ganhou_meta === true || r.ganhou_meta == 1 ? "S"
                    : r.ganhou_meta === false || r.ganhou_meta == 0 ? "N"
                    : r.ganhou_meta;
          if (val !== this.filters.ganhouMeta) return false;
        }
        return true;
      });
    },

    totalBonusPago() {
      return this.meta.rows
        .filter(r => r.ganhou_meta === "S" || r.ganhou_meta === true || r.ganhou_meta == 1)
        .reduce((sum, r) => sum + (parseFloat(r.valor_bonus_pagamento) || 0), 0);
    },

    totalRealizado() {
      const total = this.meta.rows
        .filter(r => !ehLinhaComissao(r))
        .reduce((s, r) => s + (parseFloat(r.valor_realizado) || 0), 0);
      return Number.isInteger(total)
        ? total.toLocaleString("pt-BR")
        : total.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  }
};

export default apuracaoTipoMixin;
